import React, { useState, useEffect } from "react";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import isEmpty from "lodash/isEmpty";
import { ToastContainer } from "react-toastify";
import { confirmLogin, loginAction } from "@/actions/loginAction";
import errorMessages from "@/constant/errorMessages";
import { publicRoutePaths } from "@/routes/public.routes.config";
import { useAuth } from "@/AuthProvider";
import { showSuccessMessage } from "@/utils/common";
import regExp from "@/constant/regExpressions";
import Button from "@/components/Button";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import loginThumb from "@/assets/images/webp/login-thumb-bg.webp";
import { trim } from "lodash";

const Index = (props) => {
  let nav = useNavigate("");
  const { logined } = useAuth();
  const email1 = localStorage.getItem("email");
  const password1 = localStorage.getItem("password");
  const rememberMeToken = localStorage.getItem("rememberMeToken");
  const [errors, setErrors] = useState({});
  const [email, setEmail] = useState(email1);
  var [isButtonDisabled, setisButtonDisabled] = useState(false);

  let decodedPassword = password1;

  if (!isEmpty(password1)) {
    decodedPassword = atob(password1);
  } else {
    decodedPassword = "";
  }

  const [password, setPassword] = useState(decodedPassword);
  const [showPassword, setshowPassword] = useState(false);
  const [isRememberMeChecked, setisRememberMeChecked] = useState(false);
  // const [mediummodalShow, setMediumModalShow] = useState(false);
  const [userId, setUserId] = useState(null);
  const [showConfirmLogin, setShowConfirmLogin] = useState(false);

  const emailPattern = regExp.email;

  const handleShowPassword = () => {
    setshowPassword(!showPassword);
  };


  const handleChange = (e) => {
    setisRememberMeChecked((prev) => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validation()) {
      setisButtonDisabled(true);
      //setMediumModalShow(false);
      setShowConfirmLogin(false);
      await props
        .login(email, trim(password), isRememberMeChecked)
        .then((response) => {
          setisButtonDisabled(false);
          if (response.status === true) {
            if (response.data.popup === true) {
              setUserId(response.data.user_id);
              //setMediumModalShow(true);
              setShowConfirmLogin(true);
            } else {
              const data = response.data;
              showSuccessMessage("Login Successful");
              setTimeout(() => logined(data), 1000);
            }
          } else {
            const errors = {};

            if (response.status === false) {
              if (response.message === "Validation Error") {
                if (!isEmpty(response.error.email)) {
                  errors.email = response.error.email[0];
                }
                if (!isEmpty(response.error.password)) {
                  errors.password = response.error.password[0];
                }
              }
              if (response.message === "Please provide valid credentials") {
                errors.unauthorised = response.message;
              }
              if (response.message === "Your account is currently inactive. Please contact administrator") {
                errors.inActiveProfile = response.message;
              }
              if (response.message === "The email is not registered.") {
                errors.noEmail = response.message;
              }
              if (!response) {
                errors.somethingWentWrong = "Something went wrong";
              }
            }

            setErrors(errors);
          }
        })
        .catch((error) => {
          setisButtonDisabled(false);
          // console.log(error);
        });
    }
  };

  const handleKeyDown = (e) => {
    // console.log('eeeeeeeeeeeeeee', e.code);
    if (e.code === "Space") {
      e.preventDefault();
    }
  };

  const validation = () => {
    const errors = {};
    if (email === "" || email === null) {
      errors.email = errorMessages.FIELD_REQUIRED;
    } else if (emailPattern.test(email) === false) {
      errors.email = errorMessages.INVALID_EMAIL;
    }
    if (password === "" || password === null) {
      errors.password = errorMessages.FIELD_REQUIRED;
    }
    setErrors(errors);
    return Object.keys(errors).length > 0;
  };

  const handleConfirmLoginClick = async () => {
    if (userId !== null || userId !== "") {
      try {

        await props.confirm_login(userId).then((response) => {
          if (response.status === 200 || response.data.status === true) {
            localStorage.removeItem("token");
            localStorage.removeItem("user");
            localStorage.setItem("token", response.data.data.token);
            localStorage.setItem("user", JSON.stringify(response.data.data));

            //setMediumModalShow(false);
            //setShowConfirmLogin(false);
            showSuccessMessage("Login Successful");
            const data = response.data.data;
            setTimeout(() => logined(data), 1000);
          }
        }).catch((err) => {
          console.log("Error ============ ", err);
        });

      } catch (err) {
        console.error(err);
      }
    }
  };

  const handleFocusOut = async (e) => {
    const verrors = { ...errors };
    if (e.target.name === "email") {
      if (e.target.value === "" || e.target.value === null) {
        verrors.email = errorMessages.FIELD_REQUIRED;
      } else if (emailPattern.test(e.target.value) === false) {
        verrors.email = errorMessages.INVALID_EMAIL;
      } else {
        verrors.email = "";
      }
    }
    if (e.target.name === "password") {
      if (e.target.value === "" || e.target.value === null) {
        verrors.password = errorMessages.FIELD_REQUIRED;
      } else {
        verrors.password = "";
      }
    }

    setErrors(verrors);
    return Object.keys(errors).length > 0;
  };

  const handleCancelClick = () => {
    setShowConfirmLogin(false);
  }

  useEffect(() => {
    if (rememberMeToken) {
      setisRememberMeChecked(true);
    } else {
      setisRememberMeChecked(false);
    }
  }, [rememberMeToken]);

  const styleError = {
    display: "block",
  };

  return (
    <section className="registration-wrape login-page-wrape">
      <SeoHelmet
        title={seoConfig.login.title}
        description={seoConfig.login.description}
        keywords={seoConfig.login.keywords}
        author={seoConfig.login.author}
      />
      <div className="container">
        <div className="row">
          <div className="col-xxl-6 col-xl-6 col-lg-5 col-md-4 col-sm-12 "></div>
          <div className="col-xxl-6 col-xl-6 col-lg-7 col-md-8 col-sm-12">
            <div className="form-pad">
              <div className="section-head">
                <h2>
                  {!showConfirmLogin ? 'Welcome Back!' : 'Confirm & Sign in'}
                </h2>
                <p className="text">
                  {!showConfirmLogin ? 'Please sign-in to your account to connect with your partner.' : ''}
                </p>
                <img src={loginThumb} alt="Aero Plane" className="head-thumb" />
              </div>
              {
                !showConfirmLogin && <form id="account-detail" onSubmit={handleSubmit}>
                  <div className="row">
                    {/* Email */}
                    <div className="col-xxl-12">
                      <div className="error-wrape">
                        {errors.unauthorised && (
                          <div className="invalid-feedback" style={styleError}>
                            {errors.unauthorised}
                          </div>
                        )}
                        {errors.noEmail && (
                          <div className="invalid-feedback" style={styleError}>
                            {errors.noEmail}
                          </div>
                        )}
                        {errors.somethingWentWrong && (
                          <div className="invalid-feedback" style={styleError}>
                            {errors.somethingWentWrong}
                          </div>
                        )}
                        {errors.inActiveProfile && (
                          <div className="invalid-feedback" style={styleError}>
                            {errors.inActiveProfile}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="col-xxl-12">
                      <div className={`input-wrape ${errors.email ? 'error-show' : ''}`}>
                        <div className="input-pad">
                          <input
                            type="email"
                            className="input"
                            name="email"
                            placeholder="Enter your email*"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            onKeyDown={handleKeyDown}
                            onBlur={handleFocusOut}
                            autoComplete="off"
                          />
                          {errors.email && (
                            <div className="invalid-feedback" style={styleError}>
                              {errors.email}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Password */}
                    <div className="col-xxl-12">
                      <div className={`input-wrape ${errors.password ? 'error-show' : ''}`}>
                        <div className="input-pad icon-wrape">
                          <div className="icon-input">
                            <input
                              type={showPassword ? "text" : "password"}
                              className="input"
                              name="password"
                              placeholder="Enter password *"
                              value={password}
                              onChange={(e) => setPassword(e.target.value)}
                              onKeyDown={handleKeyDown}
                              onBlur={handleFocusOut}
                            />
                            <span
                              className="input-group-text"
                              onClick={handleShowPassword}
                            >
                              <i
                                className={
                                  !showPassword
                                    ? "fa-regular fa-eye"
                                    : "fa-solid fa-eye-slash"
                                }
                              ></i>
                            </span>
                          </div>
                          {errors.password && (
                            <div className="invalid-feedback" style={styleError}>
                              {errors.password}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Remember Me */}
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div className="input-wrape">
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input login-check"
                            checked={isRememberMeChecked}
                            onChange={handleChange}
                          />
                          <label className="form-check-label">Remember me</label>
                        </div>
                      </div>
                    </div>

                    {/* Forgot Password + Login Button */}
                    <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-6">
                      <div className="login-text">
                        <span
                          onClick={() => nav(publicRoutePaths.FORGOT_PSWD.path)}
                        >
                          Forgot password?
                        </span>
                      </div>
                    </div>

                    <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 inquiry-form-btn">
                      <Button
                        className="btn secondry-btn"
                        type="submit"
                        disabled={isButtonDisabled}
                      >
                        Login
                      </Button>
                    </div>
                    {/* Signup */}
                    <div className="col-xxl-12">
                      <p className="text-center register-line">
                        <span className="login-subtitle">Don't Have an Account? </span>
                        <span
                          className="login-text"
                          onClick={() => nav(publicRoutePaths.REGISTRATION.path)}
                        >
                          Register Now.
                        </span>
                      </p>
                    </div>
                  </div>
                </form>
              }
              {
                showConfirmLogin && <>
                  <div id="account-detail" className="confirm-popup">
                    <div className="row">
                      <div className="col-md-12">
                        <p>
                          We have found another active session with same user. Confirm if you
                          would like to sign out from that session.
                        </p>
                      </div>
                      <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 inquiry-form-btn">
                        <button type="button" className="btn outline" onClick={handleCancelClick}>
                          Cancel
                        </button>
                        <Button
                          className="btn secondry-btn"
                          type="button"
                          // disabled={isButtonDisabled}
                          onClick={handleConfirmLoginClick}
                        >
                          Confirm & Sign in
                        </Button>
                      </div>
                    </div>
                  </div>
                </>
              }

            </div>
          </div>
        </div>
      </div>

      <ToastContainer />
      <ConsentManager data={""} />
    </section>

  );
}

const mapStateToProps = (state) => {
  return {
    auth: state.auth.login,
    // authError: state.auth.errorMessages
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    login: (email, pswd, isRememberMeChecked) =>
      dispatch(loginAction(email, pswd, isRememberMeChecked)),
    confirm_login: (user_id) => dispatch(confirmLogin(user_id))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Index);
